var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04417 4.69531H11.4784C11.6168 4.69531 11.7495 4.75028 11.8473 4.84812C11.9451 4.94596 12.0001 5.07866 12.0001 5.21702C12.0001 5.35539 11.9451 5.48809 11.8473 5.58593C11.7495 5.68377 11.6168 5.73874 11.4784 5.73874H1.04417C0.905806 5.73874 0.773107 5.68377 0.675267 5.58593C0.577427 5.48809 0.522461 5.35539 0.522461 5.21702C0.522461 5.07866 0.577427 4.94596 0.675267 4.84812C0.773107 4.75028 0.905806 4.69531 1.04417 4.69531Z",
    fill: "#575B86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26034 5.21777L5.58742 9.54381C5.68538 9.64177 5.74042 9.77464 5.74042 9.91318C5.74042 10.0517 5.68538 10.1846 5.58742 10.2826C5.48946 10.3805 5.35659 10.4355 5.21805 10.4355C5.07951 10.4355 4.94664 10.3805 4.84868 10.2826L0.153272 5.58715C0.104687 5.53868 0.0661402 5.48111 0.0398392 5.41773C0.0135383 5.35435 0 5.2864 0 5.21777C0 5.14915 0.0135383 5.0812 0.0398392 5.01782C0.0661402 4.95444 0.104687 4.89687 0.153272 4.8484L4.84868 0.152999C4.94664 0.0550352 5.07951 0 5.21805 0C5.35659 0 5.48946 0.0550352 5.58742 0.152999C5.68538 0.250962 5.74042 0.383829 5.74042 0.522371C5.74042 0.660912 5.68538 0.793779 5.58742 0.891742L1.26034 5.21777Z",
    fill: "#575B86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back_arrow_icon.19dc81af82c7f5c2fc2b26d6988d6f6e.svg";
export { ForwardRef as ReactComponent };